import React from 'react';
import styles from './spinner.less';

const Spinner = ({ size = 'sm', type = 'default' }) => {
  return (
    <div className={`${styles[size]} ${styles.spinner} ${styles[type]}`} />
  );
};

export default Spinner;
